import { ApplicationConfig, APP_INITIALIZER, ErrorHandler, inject } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { authInterceptor } from './core/http/auth.interceptor';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { DatePipe } from '@angular/common'; // ✅ ajouter
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateMultiHttpLoader } from '@ngx-translate/http-loader';
import { I18N_NAMESPACES } from './core/i18n-namespaces';
import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    // Bloque la 1re navigation le temps du bootstrap (recharge /me si token)
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),

    // ✅ Fournir DatePipe globalement pour pouvoir l'injecter (inject(DatePipe))
    DatePipe,

    // i18n back-office (langue d'interface DO/RAQ) — distinct des langues patient
    // gérées côté backend. Le français reste la langue par défaut/fallback tant
    // qu'une clé n'existe pas encore dans une autre langue.
    // Un fichier de traduction par fonctionnalité (assets/i18n/<namespace>/{fr,en}.json)
    // plutôt qu'un fr.json/en.json monolithique : chaque page ne charge/édite que le
    // sien, ce qui évite les conflits quand plusieurs pages sont traduites en parallèle.
    provideTranslateService({
      lang: 'fr',
      fallbackLang: 'fr',
      loader: provideTranslateMultiHttpLoader({
        resources: I18N_NAMESPACES.map(ns => ({ prefix: `/assets/i18n/${ns}/`, suffix: '.json' })),
      }),
    }),

    // Reconstruit la session au boot si un token valable existe
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: () => {
        const auth = inject(AuthService);
        return () => firstValueFrom(auth.bootstrap());
      },
    },

    // Sentry : les erreurs Angular non gérées sont envoyées à Sentry (puis affichées dans la
    // console comme avant). Seulement si un DSN est configuré (Sentry initialisé dans main.ts) ;
    // sinon on garde l'ErrorHandler par défaut d'Angular. Pas de fenêtre de signalement.
    ...(environment.sentryDsn
      ? [{ provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) }]
      : []),
  ],
};
